var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_412",
    "data-name": "Groupe 412",
    transform: "translate(-14.833 -194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 16,
    height: 16,
    transform: "translate(14.833 194)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M8.666,12A.667.667,0,0,1,8,11.333a3.333,3.333,0,1,0-6.667,0,.667.667,0,1,1-1.333,0,4.664,4.664,0,0,1,7.96-3.3,3.333,3.333,0,0,1,5.373,2.636.667.667,0,0,1-1.333,0A2,2,0,0,0,8.762,9.1a4.669,4.669,0,0,1,.571,2.234A.668.668,0,0,1,8.666,12ZM10,6.667a2,2,0,1,1,2-2A2,2,0,0,1,10,6.667ZM10,4a.667.667,0,1,0,.667.667A.667.667,0,0,0,10,4ZM4.667,5.333A2.667,2.667,0,1,1,7.333,2.666,2.667,2.667,0,0,1,4.667,5.333Zm0-4A1.334,1.334,0,1,0,6,2.666,1.334,1.334,0,0,0,4.667,1.333Z",
    transform: "translate(15.833 196)",
    fill: "#C5A47E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.9a66d940a49fdc2fa0d8e237b3cc1d20.svg";
export { ForwardRef as ReactComponent };